export class QueryFilter {
    skip?: number;
    top?: number;
}
